export const environment = {
  production: true,
  razorpayKey: 'rzp_live_TpJD55X4i6mqMu',
  apiUrl: 'https://ruralx.in/api',
  imageBaseUrl: 'https://ruralx.in/api/',
  getUserDetailsApiURL: 'https://ruralx.in/api/getUserLoginDetails.php',
  searchApiUrl: 'https://ruralx.in/api/search_product.php',
  voiceSearchApiUrl: 'https://ruralx.in/api/voice_search_product.php',
  uploadDataApiUrl: 'https://ruralx.in/api/uploadAdminData.php',
  insertUserDetailsApiUrl: 'https://ruralx.in/api/insertUserDetailsData.php',
  getProductListDetailsApiUrl: 'https://ruralx.in/api/getProductDetails.php',
  getProductNotifyApiUrl: 'https://ruralx.in/api/getProductNotification.php',
  insertshippingAddressApiUrl: 'https://ruralx.in/api/insertShippingAddress.php',
  getShippingAddressApiUrl: 'https://ruralx.in/api/getShippingAddress.php',
  updateShippingAddressApiUrl: 'https://ruralx.in/api/updateShippingaddress.php',
  deleteShippingAddressApiUrl: 'https://ruralx.in/api/deleteShippingAddress.php',
  getCategoryListApiUrl: 'https://ruralx.in/api/get_all_category.php',
  getMainCategoryApiUrl: 'https://ruralx.in/api/mainCategorySearchData.php',
  placeOrderApiUrl: 'https://ruralx.in/api/place_order.php',
  getOrderListApiUrl: 'https://ruralx.in/api/getOrders.php',
  getOrderByIdApiUrl: 'https://ruralx.in/api/get_order_by_id.php',
  upadateStatusApiUrl: 'https://ruralx.in/api/update_order_status.php',
  submitReviewApiUrl: 'https://ruralx.in/api/submit-review.php',
  getReviewApiUrl: 'https://ruralx.in/api/get-review.php',
  submitReviewHelpfulApiUrl: 'https://ruralx.in/api/review-helpful.php',
  getReviewSummaryApiUrl: 'https://ruralx.in/api/get-review-summary.php',
  getReturnOrderApiUrl: 'https://ruralx.in/api/create-return.php',
  addToCartApiUrl: 'https://ruralx.in/api/addToCart.php',
  getCartApiUrl: 'https://ruralx.in/api/getCart.php',
  updateCartQtyApiUrl: 'https://ruralx.in/api/updateCartQuantity.php',
  getProductByIdApiUrl: 'https://ruralx.in/api/getProductById.php',
  forgotPasswordSendOtpApiUrl: 'https://ruralx.in/api/forgot-password-send-otp.php',
  verifyForgotOtpApiUrl: 'https://ruralx.in/api/verify-forgot-otp.php',
  resetPasswordApiUrl: 'https://ruralx.in/api/reset-password.php',
  deleteAccountApiUrl: 'https://ruralx.in/api/delete-account.php',
  checkPincodeApiUrl: 'https://ruralx.in/api/check-pincode.php',
  dashboardProductApiUrl: 'https://ruralx.in/api/dashboard_products.php',
};